module.exports = __webpack_public_path__ + "static/media/mine_banner_100.a7ecf710.png";